import React from 'react';
import '../css/donate.css';
import Navbar from "../components/Navbar";
import Footer from '../components/Footer';
import BackToTop from '../components/BackToTop';
import PageHeader from "../components/PageHeader";
import cs from "../assets/Team/communitu-support.jpg";
import gn from "../assets/Team/Gita_Nagari.jpg";
import support from "../assets/BT_SWAMI_Portraits/BTSwami-KuntiMadhava.jpg";

const donationData = [
  {
    title: "Support Gita Nagari Home",
    description:
      "Gita Nagari is the sacred place where Bhakti Tirtha Swami Maharaj left his body. Your support helps preserve this spiritual sanctuary for future generations.",
    image: gn,
    onetimePaymentLink: "https://www.paypal.com/us/fundraiser/charity/2008838"
  },
  {
    title: "Support Our Community",
    description:
      "Contribute to our vibrant devotional community, enabling programs, prasadam distribution, outreach, and spiritual education for all ages. This is a sacred opportunity to keep the mission alive.",
    image: cs,
    onetimePaymentLink: "https://www.paypal.com/us/fundraiser/charity/2008838"
  },
];

const DonatePage = () => {
  return (
    <>
        <Navbar />
        <PageHeader title="Support Us" path="/donate" name="Support Us" />
        <div className="donate-main">
            <div className='donate-container'>
                <h1 className="donate-title">Support Our Mission</h1>
                <div className="card-grid">
                    {donationData.map((item, idx) => (
                    <div key={idx} className="donation-card">
                        <img src={item.image} alt={item.title} className="card-image" />
                        <div className="card-content">
                        <h2 className="card-title">{item.title}</h2>
                        <p className="card-description">{item.description}</p>
                        <div className="center-button-container">
                          {item.onetimePaymentLink && (
                            <a
                              href={item.onetimePaymentLink}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="primary-button"
                            >
                              Donate Today
                            </a>
                          )}
                          {item.monthlyPaymentLink && (
                            <a
                              href={item.monthlyPaymentLink}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="primary-button"
                            >
                              Become a Monthly Donor
                            </a>
                          )}
                      </div>
                    </div>
                </div>
                    ))}
                </div>
            </div>
        </div>
        <Footer />
        <BackToTop />
    </>
    
  );
};

export default DonatePage;
